import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import { IPopupService } from "@shared/interfaces/popup-service.interface";
import { PopupDto } from "@shared/types/popup/popup.dto";
import { PopupListPaginatedDto } from "@shared/types/popup/popups-list-paginated.dto";

@appInjectable()
export class PopupService extends BaseService implements IPopupService {
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  create: IPopupService["create"] = async (dto) => {
    const { data } = await this.httpClient.post<PopupDto>(
      "/popups",
      {
        ...dto,
      },
      {
        baseURL: this.baseURL,
      },
    );

    return data;
  };

  update: IPopupService["update"] = async (dto) => {
    const { data } = await this.httpClient.patch<PopupDto>(
      `/popups/${dto.id}`,
      {
        ...dto,
      },
      {
        baseURL: this.baseURL,
      },
    );

    return data;
  };

  list: IPopupService["list"] = async (dto) => {
    const { data } = await this.httpClient.get<PopupListPaginatedDto>(
      "/popups",
      {
        params: dto,
        baseURL: this.baseURL,
      },
    );

    return data;
  };

  delete: IPopupService["delete"] = async (dto) => {
    const { data } = await this.httpClient.delete<PopupDto>(
      `/popups/${dto.id}`,
      {
        baseURL: this.baseURL,
      },
    );
    return data;
  };
}
